import { makeStyles } from '@material-ui/core'
import React, { useContext, useEffect, useState } from 'react'

import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { calculateMonthRange, getNumbersByValidity, sortByName, validityOptions } from '../../shared/constants'
import { useStore } from '../../hooks/CompanyConfiguration/useStore'
import CustomAddForm from '../version-4/MasterForms/CustomAddForm'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#EFF3FE',
    borderRadius: '10px',
  },
  input: {
    marginTop: '0px',
  },
  boder: {
    border: '1px solid #CCCCCC',
    borderRadius: '5px',
  },
  displayNone: {
    display: 'none',
  },
}))

export default function TargetForm({ form, setForm }) {
  const { getAllStore } = useStore()
  const { stores } = useContext(ConfigurationContext)

  useEffect(() => {
    getAllStore()
  }, [])

  const fieldData = (label, value, name, handleChange) => {
    return { label, value, name, type: 'number', handleChange }
  }

  let amountField = []

  //console.log('form ', form)

  for (let index = 0; index < form.noOfPeriod; index++) {
    amountField.push(
      fieldData(`Amount ${index + 1}`, form.amount[index], `amount${index}`, (value) => {
        let amo = form.amount
        amo[index] = value
        setForm({ ...form, amount: amo })
      })
    )
  }

  let inputField = [
    { label: 'Target Code', value: form.targetCode, name: 'targetCode' },
    { label: 'Name', value: form.name, name: 'name', input: true, display: true },
    {
      label: 'Validity',
      value: form.validity,
      name: 'validity',
      options: validityOptions,
      fieldName: 'label',
      fieldValue: 'value',
    },
    {
      label: 'Amount',
      value: form.singleAmount,
      name: 'singleAmount',
      noDisplay: form.validity && form.validity === 'CUSTOM' ? false : true,
      type: 'NUMBER',
    },
    {
      label: `Number of ${form.validity && form.validity.toLowerCase().substring(0, form.validity.length - 2)}`,
      value: form.noOfPeriod,
      name: 'noOfPeriod',
      options: getNumbersByValidity(form.validity),
      noDisplay: form.validity && form.validity !== 'CUSTOM' ? false : true,
      handleChange: (value) => {
        setForm({ ...form, noOfPeriod: value, amount: form.amount.slice(0, value) })
      },
    },
    ...amountField,
    {
      label: 'From',
      value: form.from,
      name: 'from',
      type: 'DATE',
    },
    {
      label: 'To',
      value: calculateMonthRange(form.from, form.noOfPeriod, form.validity),
      name: 'to',
      type: 'DATE',
      disabled: form.validity === 'CUSTOM' ? false : true,
    },

    {
      label: 'Store',
      value: form.store,
      name: 'store',
      options: sortByName(stores),
      fieldName: 'name',
      fieldValue: '_id',
    },
  ]

  return <CustomAddForm state={form} setState={setForm} data={inputField} />
}
